// Get the container
const slideContainer7 = document.querySelector('.slide_container7');

// URLs for desktop images
const desktopImageUrls7 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/HPWarehouseDesktop.png?v=1723784319',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/HPWarehouseDesktop_1.png?v=1723784639'
];

// URLs for mobile images
const mobileImageUrls7 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/WarehouseMobile.png?v=1723784377'
];

// Function to determine screen size and load appropriate images
function loadImages7() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainer7.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        // Create and append mobile images
        mobileImageUrls7.forEach(url => {
            const mobileImage = document.createElement('img');
            mobileImage.src = url;
            mobileImage.alt = 'Mobile image';
            mobileImage.className = 'mobile-image7';
            slideContainer7.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        // Create and append desktop images
        desktopImageUrls7.forEach(url => {
            const desktopImage = document.createElement('img');
            desktopImage.src = url;
            desktopImage.alt = 'Desktop image';
            desktopImage.className = 'desktop-image7';
            slideContainer7.appendChild(desktopImage);
        });
    }
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImages7();
    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', loadImages7);

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTime7 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdown7() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTime7 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown7').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown7').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdown7, 1000);
    }

    updateCountdown7();
});
